/**
 * @generated SignedSource<<b5cf0b18f49e06d3496a878cd224e66b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespL1Landing_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespPersonalizedAuctionsModuleLazy_user">;
  readonly " $fragmentType": "SbRespL1Landing_user";
};
export type SbRespL1Landing_user$key = {
  readonly " $data"?: SbRespL1Landing_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespL1Landing_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespL1Landing_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespPersonalizedAuctionsModuleLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3e8e3f51f675c8c5ddb5ec6b6ba40862";

export default node;
